
import React from 'react';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { PerksFormData } from '@/hooks/usePerksForm';

interface PerkFieldProps {
  form: UseFormReturn<PerksFormData>;
  fieldName: keyof PerksFormData;
  label: string;
  placeholder: string;
  showDescription?: boolean;
}

export const PerkField: React.FC<PerkFieldProps> = ({
  form,
  fieldName,
  label,
  placeholder,
  showDescription = false,
}) => {
  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Input placeholder={placeholder} {...field} />
          </FormControl>
          {showDescription && (
            <FormDescription>
              Add a key perk your company offers
            </FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
